import upsell from "../upsell"
import { TrackingManager } from "../../../../../lib/common/js/services/tracking/trackingManager"

export default (getView) => (nextStepPath) => ({
  ...getView(nextStepPath),
  ...upsell("workouts"),

  internalTracker: new TrackingManager(
    window.trackingConfig.enabledTrackingServices,
    pipelineConfig,
  ),

  init() {
    this.commonInit()
  },

  onInit() {
    this.initUpsell()
  },

  handleOfferAccept() {
    this.internalTracker.trackClick({ clickName: "Workouts Accepted Clicked" })
    this.purchase()
  },

  handleOfferDecline() {
    this.internalTracker.trackClick({ clickName: "Workouts Rejected Clicked" })
    this.goToNextUpsellOffer(true)
  },
})